module.exports = {"id":"177388","name":"Dimitri Payet","rating":"83","photo":"./data/images/photos/1/177388.png","club":{"name":"OM","logo":"./data/images/clubs/OM.png"},"positions":["AG","MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DimitriPayet0.json
// module id = 1104
// module chunks = 0